import React from "react";
import InstagramGlyph from "./InstagramGlyph";
import { instagramIsNext, openReviewSheet, type GateProfile } from "../lib/connectBank";
import { t } from "../i18n";
import "./VerifyInstagramBanner.css";

// Requests tab: the bank is connected and Instagram is the one thing left
// (founder, 2026-11-03: "otherwise, how will they know it's missing"). It stays
// until they've done it; the whole banner opens the sheet every paid feature
// opens (components/ReviewSheet). Its glyph is the Connect Instagram screens'.
export default function VerifyInstagramBanner({ profile }: { profile: GateProfile }) {
  if (!instagramIsNext(profile)) return null;
  return (
    <button type="button" className="vib" onClick={openReviewSheet}>
      <span className="vib-ic" aria-hidden="true">
        <InstagramGlyph size={24} tight />
      </span>
      <span className="vib-text">
        <span className="vib-title">{t("verifyBanner.title")}</span>
        <span className="vib-sub">{t("verifyBanner.lastStep")}</span>
      </span>
      <span className="vib-go">{t("editProfileSheet.verify")}</span>
    </button>
  );
}
